import { render } from "./FollowerButton.vue?vue&type=template&id=bd0dc24e"
import script from "./FollowerButton.vue?vue&type=script&lang=js"
export * from "./FollowerButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__